import { EtablissementProjection } from '../etablissement';
import { RncpDto } from '../rncp';
import { servicesApi } from '../services';

const ORGANISMES_ETABLISSEMENTS_RNCPS_URL_PREFIX = (id: number, etablissementId: number) => `organismes/${id}/etablissements/${etablissementId}/rncps`;

const organismeEtablissementApi = servicesApi.injectEndpoints!({
  endpoints: (build) => ({

    getOrganismeEtablissementRncps: build.query<RncpDto[], GetOrganismeEtablissementRncpsQueryArgs, any>({
      query: ({ id, etablissementId }) => ORGANISMES_ETABLISSEMENTS_RNCPS_URL_PREFIX(id, etablissementId),
      providesTags: ['EtablissementsRncps'],
    }),

    replaceOrganismeEtablissementRncps: build.mutation<void, ReplaceOrganismeEtablissementRncpsMutationArgs, any>({
      query: ({ id, etablissementId, body }) => ({
        url: ORGANISMES_ETABLISSEMENTS_RNCPS_URL_PREFIX(id, etablissementId),
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['EtablissementsRncps', 'Etablissements'],
    }),
  }),
});

interface GetOrganismeEtablissementRncpsQueryArgs {
  id: number;
  etablissementId: number;
  projection?: EtablissementProjection;
}

interface ReplaceOrganismeEtablissementRncpsMutationArgs {
  id: number;
  etablissementId: number;
  body: ReplaceOrganismeEtablissementRncpsBody;
}

interface ReplaceOrganismeEtablissementRncpsBody {
  rncps: { rncpId: number; ordre: number; }[];
}

export const {
  useGetOrganismeEtablissementRncpsQuery,
  useReplaceOrganismeEtablissementRncpsMutation,
  useLazyGetOrganismeEtablissementRncpsQuery,
} = organismeEtablissementApi;